export const tileIndex = {
  ARTS: {
    PARTIAL: require('../assets/purple_swoop.png'),
    IN_PROGRESS: require('../assets/purple_dot.png'),
    HONORS: require('../assets/purple_star.png'),
  },
  ELECTIVES: {
    PARTIAL: require('../assets/light_blue_swoop.png'),
    IN_PROGRESS: require('../assets/light_blue_dot.png'),
    HONORS: require('../assets/light_blue_star.png'),
  },
  HEALTH: {
    PARTIAL: require('../assets/orange_swoop.png'),
    IN_PROGRESS: require('../assets/orange_dot.png'),
    HONORS: require('../assets/orange_star.png'),
  },
  LANGUAGE_ARTS: {
    PARTIAL: require('../assets/dark_blue_swoop.png'),
    IN_PROGRESS: require('../assets/dark_blue_dot.png'),
    HONORS: require('../assets/dark_blue_star.png'),
  },
  MATH: {
    PARTIAL: require('../assets/yellow_swoop.png'),
    IN_PROGRESS: require('../assets/yellow_dot.png'),
    HONORS: require('../assets/yellow_star.png'),
  },
  PE: {
    PARTIAL: require('../assets/light_green_swoop.png'),
    IN_PROGRESS: require('../assets/light_green_dot.png'),
    HONORS: require('../assets/light_green_star.png'),
  },
  SCIENCE: {
    PARTIAL: require('../assets/red_swoop.png'),
    IN_PROGRESS: require('../assets/red_dot.png'),
    HONORS: require('../assets/red_star.png'),
  },
  SOCIAL_STUDIES: {
    PARTIAL: require('../assets/green_swoop.png'),
    IN_PROGRESS: require('../assets/green_dot.png'),
    HONORS: require('../assets/green_star.png'),
  },
};
